const backgroundFootageBaseKey = "assets/video/background-footage";
function gameplayClip(filenameBase, clipNumberLabel, durationMs) {
    return {
        clipId: filenameBase,
        clipNumberLabel,
        assetKey: `${backgroundFootageBaseKey}/${filenameBase}.mp4`,
        previewAssetKey: `${backgroundFootageBaseKey}/${filenameBase}-preview.mp4`,
        durationApproxSeconds: Math.round(durationMs / 1000),
    };
}
export const gameplaySeriesCatalog = [
    {
        seriesId: "abstract",
        label: "Abstract",
        clips: [
            gameplayClip("abstract-red-bokeh", "Red Bokeh", 120000),
            gameplayClip("abstract-red-motion", "Red Motion", 60000),
            gameplayClip("cyberpunk-cityscape", "Cyberpunk Cityscape", 59000),
        ],
    },
    {
        seriesId: "gta_v_mega_ramp",
        label: "GTA V Mega Ramp",
        clips: [
            gameplayClip("gta-v-mega-ramp-0", "000", 120000),
            gameplayClip("gta-v-mega-ramp-1", "001", 120000),
            gameplayClip("gta-v-mega-ramp-2", "002", 120000),
            gameplayClip("gta-v-mega-ramp-3", "003", 73000),
        ],
    },
    {
        seriesId: "minecraft_parkour",
        label: "Minecraft Parkour",
        clips: [
            gameplayClip("minecraft-parkour-0", "000", 120000),
            gameplayClip("minecraft-parkour-1", "001", 120000),
            gameplayClip("minecraft-parkour-2", "002", 120000),
            gameplayClip("minecraft-parkour-3", "003", 120000),
            gameplayClip("minecraft-parkour-4", "004", 119000),
            gameplayClip("minecraft-parkour-5", "005", 120000),
            gameplayClip("minecraft-parkour-6", "006", 120000),
            gameplayClip("minecraft-parkour-7", "007", 120000),
            gameplayClip("minecraft-parkour-8", "008", 120000),
            gameplayClip("minecraft-parkour-9", "009", 120000),
            gameplayClip("minecraft-parkour-10", "010", 120000),
            gameplayClip("minecraft-parkour-11", "011", 120000),
            gameplayClip("minecraft-parkour-12", "012", 40000),
        ],
    },
    {
        seriesId: "satisfying_clips",
        label: "Satisfying Clips",
        clips: [
            gameplayClip("satisfying-clips-0", "000", 120000),
            gameplayClip("satisfying-clips-1", "001", 120000),
            gameplayClip("satisfying-clips-2", "002", 120000),
            gameplayClip("satisfying-clips-3", "003", 120000),
            gameplayClip("satisfying-clips-4", "004", 60000),
            gameplayClip("satisfying-clips-5", "005", 120000),
            gameplayClip("satisfying-clips-6", "006", 120000),
            gameplayClip("satisfying-clips-7", "007", 120000),
            gameplayClip("satisfying-clips-8", "008", 120000),
            gameplayClip("satisfying-clips-9", "009", 120000),
            gameplayClip("satisfying-clips-10", "010", 39000),
            gameplayClip("satisfying-clips-11", "011", 120000),
            gameplayClip("satisfying-clips-12", "012", 120000),
            gameplayClip("satisfying-clips-13", "013", 120000),
            gameplayClip("satisfying-clips-14", "014", 120000),
            gameplayClip("satisfying-clips-15", "015", 82000),
            gameplayClip("satisfying-clips-16", "016", 120000),
            gameplayClip("satisfying-clips-17", "017", 120000),
            gameplayClip("satisfying-clips-18", "018", 120000),
            gameplayClip("satisfying-clips-19", "019", 120000),
            gameplayClip("satisfying-clips-20", "020", 14000),
        ],
    },
    {
        seriesId: "subway_surfers",
        label: "Subway Surfers",
        clips: [
            gameplayClip("subway-surfers-0", "000", 120000),
            gameplayClip("subway-surfers-1", "001", 120000),
            gameplayClip("subway-surfers-2", "002", 120000),
            gameplayClip("subway-surfers-3", "003", 120000),
            gameplayClip("subway-surfers-4", "004", 119000),
            gameplayClip("subway-surfers-5", "005", 120000),
            gameplayClip("subway-surfers-6", "006", 120000),
            gameplayClip("subway-surfers-7", "007", 120000),
            gameplayClip("subway-surfers-8", "008", 120000),
            gameplayClip("subway-surfers-9", "009", 75000),
        ],
    },
];
function flattenGameplayClipOptions() {
    return gameplaySeriesCatalog.flatMap((series) => series.clips.map((clip) => {
        const option = {
            id: clip.clipId,
            label: `${series.label} · ${clip.clipNumberLabel}`,
            assetKey: clip.assetKey,
        };
        if (clip.previewAssetKey) {
            option.previewAssetKey = clip.previewAssetKey;
        }
        if (clip.thumbnailAssetKey) {
            option.thumbnailAssetKey = clip.thumbnailAssetKey;
        }
        return option;
    }));
}
/** Flat list of clips (ids + asset keys) for URL maps, quotes, and validation. */
export const gameplayClipOptions = flattenGameplayClipOptions();
export const defaultGameplayClipId = gameplaySeriesCatalog[0]?.clips[0]?.clipId ?? "abstract-red-bokeh";
export function findGameplayClipById(clipId) {
    for (const series of gameplaySeriesCatalog) {
        const clip = series.clips.find((c) => c.clipId === clipId);
        if (clip) {
            return { series, clip };
        }
    }
    return null;
}
export function listSeriesIds() {
    return gameplaySeriesCatalog.map((s) => s.seriesId);
}
